// extracted by mini-css-extract-plugin
module.exports = {"openingQuote":"quote_openingQuote__54m0o","closingQuote":"quote_closingQuote___HUN_"};